import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { c as w } from "./clsx-OuTLNxxd.js";
import { I as l } from "./icon-DkgzfU3h.js";
import "./components/elements/icon/iconsList.js";
import { Loader as v } from "./components/elements/loader/loader.js";
const T = "_button_51ubt_29", k = "_disabled_51ubt_46", s = {
  button: T,
  disabled: k,
  "is-primary": "_is-primary_51ubt_59",
  "is-secondary": "_is-secondary_51ubt_72",
  "is-tertiary": "_is-tertiary_51ubt_84",
  "is-eco-green": "_is-eco-green_51ubt_96",
  "is-white": "_is-white_51ubt_110",
  "is-ghost": "_is-ghost_51ubt_123",
  "is-destructive-ghost": "_is-destructive-ghost_51ubt_137",
  "is-destructive": "_is-destructive_51ubt_137",
  "is-facebook": "_is-facebook_51ubt_164",
  "is-apple": "_is-apple_51ubt_178",
  "is-google": "_is-google_51ubt_192",
  "is-collection": "_is-collection_51ubt_206",
  "is-hollow": "_is-hollow_51ubt_220",
  "is-regular": "_is-regular_51ubt_238",
  "is-medium": "_is-medium_51ubt_241",
  "is-small": "_is-small_51ubt_244",
  "is-full-width": "_is-full-width_51ubt_247",
  "dialog-overlay-show": "_dialog-overlay-show_51ubt_1",
  "dialog-content-show": "_dialog-content-show_51ubt_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_51ubt_1"
};
function L({
  color: a = "primary",
  text: u,
  size: c = "regular",
  isFullWidth: n = !1,
  icon: t,
  iconPosition: i = "left",
  iconSize: r,
  onClick: g,
  children: b,
  disabled: e,
  type: d = "button",
  className: m = "",
  href: _,
  isLoading: h,
  ...p
}) {
  const y = w(
    s.button,
    s[x[a]],
    s[B[c]],
    n && s["is-full-width"],
    e && s.disabled,
    i === "right" && s["has-icon-right"],
    m
  );
  return /* @__PURE__ */ f(
    `${_ ? "a" : "button"}`,
    {
      href: e ? void 0 : _,
      onClick: g,
      className: y,
      disabled: e,
      type: d,
      ...p,
      children: [
        h && /* @__PURE__ */ o(v, { onDark: !0, size: "small" }),
        t && i === "left" && /* @__PURE__ */ o(l, { color: "inherit", size: r, name: t }),
        b ?? u,
        t && i === "right" && /* @__PURE__ */ o(l, { color: "inherit", size: r, name: t })
      ]
    }
  );
}
const x = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  white: "is-white",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google",
  collection: "is-collection",
  hollow: "is-hollow"
}, B = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
export {
  L as B,
  x as a,
  B as b
};
